import { h, ComponentChildren } from 'preact';
import { IntlContext, Translations } from './i18n-context';

interface LightIntlProviderProps {
  definition: Translations;
  children: ComponentChildren;
}

export const LightIntlProvider = ({ definition, children }: LightIntlProviderProps) => {
  const contextValue = {
    translations: definition,
  };

  return (
    <IntlContext.Provider value={contextValue}>
      {children}
    </IntlContext.Provider>
  );
};